import axios from 'axios'
import store from "../store";
import router from '../router'
import { toastInstance } from '../main'

axios.defaults.baseURL = 'https://gateway.resolved.dominuslabs.com/api/v1/gateway'


// if (process.env.NODE_ENV === "development") {
axios.interceptors.request.use(request => {
    console.log('Starting Request', request)
    return request
})

axios.interceptors.response.use(response => {
    console.log('Response:', response)
    return response
})
// }

export const JSONClient = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        "Content-Type": "application/json"
    }
})

JSONClient.interceptors.response.use(response => {
    return response;
}, async error => {
    toastInstance.open({
        message: error.response.data.message + " Event ID: " + error.response.data.eventID,
        type: "error",
    });
    if (error.response.status === 401) {
        await store.dispatch('userStore/logout')
        router.push('/login')
    }
    return Promise.reject(error);
})


export const FormClient = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        "Content-Type": "multipart/form-data"
    }
})
